import React from "react";
import classNames from "classnames/bind";

import { Button } from "../Button";
import { ProgressBar } from "../ProgressBar";

import { useStateManager } from "utils/useStateManager";

import { ReactComponent as ArrowLeft } from "../../icons/arrow_small_l.svg";

import styles from "./Screen.module.css";

const cx = classNames.bind(styles);

type Props = {
  title: React.ReactNode;
  onBack?: (() => void) | null;
  onForward?: () => void;
  isInvalid?: boolean;
  isLoading?: boolean;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  buttonTitle?: React.ReactNode | boolean;
  withoutProducts?: boolean;
  showEmailButton?: boolean;
  showDownloadButton?: boolean
  downloadPdfHandler?: () => void
};
export const Screen: React.FC<Props> = (props) => {
  const {progress} = useStateManager();

  /*
    buttonTitle - есть на каждом экране, только на экране продукции его не передаём из-за кастомных настроек кнопок.
    showDownloadButton, showEmailButton - флаги для показа соответствуюших кнопок.Только на экране продукции
  */
  const Buttons = [
    {
      show: props.buttonTitle,
      text: props.buttonTitle,
      type: 'submit'
    } as const,
    {
      show: props.showDownloadButton,
      text: 'Скачать отчёт',
      type: 'button',
      onClick: props.downloadPdfHandler
    } as const,
    {
      show: props.showEmailButton,
      text: 'Полный отчет на почту',
      type: 'submit',
    } as const
  ].filter(button => button.show)

  const getButtons = () => (
    <>
      {Buttons.map((button, index) => (
        <div
          className={cx("button")}
          onClick={() => {
            window.scrollTo(0, 0)
            if (button.onClick) button.onClick()
          }}
          key={index}
        >
          <Button
            color="cerulean"
            block
            size="medium"
            rounded
            disabled={props.isInvalid}
            isLoading={props.isLoading}
            type={button.type}
          >
            {button.text}
          </Button>
        </div>
      ))}
    </>
  )

  const content = (
    <div className={cx("inner")}>
      <header className={cx("header")}>
        {props.onBack && (
          <button
            className={cx("back")}
            onClick={props.onBack}
            type="button"
            aria-label="Назад"
          >
            <ArrowLeft width={16} height={16}/>
          </button>
        )}
        <h1 className={cx("title")}>{props.title}</h1>
        {props.onForward && (
          <button
            className={cx("forward")}
            onClick={props.onForward}
            type="button"
            aria-label="Назад"
          >
            <ArrowLeft width={16} height={16} />
          </button>
        )}
        <ProgressBar progress={progress} />
      </header>
      <div className={cx('content')} style={props.withoutProducts ? {justifyContent: "center", rowGap: "10px"} : {}}>
        {props.withoutProducts ? (
          <>
            {getButtons()}
          </>
        ) : (
          props.children
        )}
      </div>
      {!props.withoutProducts && Buttons.length > 0 && (
        <div className={cx("footer")}>
          {getButtons()}
        </div>
      )}
    </div>
  );

  if (props.onSubmit) {
    return (
      <form className={cx("screen")} id={"screen"} onSubmit={props.onSubmit}>
        {content}
      </form>
    );
  }

  return (
    <div className={cx("screen")} id={"screen"}>
      {content}
    </div>
  );
};
